module.exports = __webpack_public_path__ + "static/media/leclerc5.e992f9d4.jpg";